const animatedTitle = () => {
  $(() => {
    const titles = document.querySelectorAll('.title-animation');

    if (!titles) {
      return;
    }

    import(/* webpackChunkName: "js/typed" */ 'typed.js').then((Module) => {
      const Typed = Module.default;
      [...titles].forEach((item) => {
        // eslint-disable-next-line
        new Typed($(item).find('.typed')[0], {
          stringsElement: $(item).find('.typed-strings')[0],
          typeSpeed: 100,
          cursorChar: '_',
        });
      });
    });
  });
}

export default animatedTitle;
